const $limit = (collection, expr, options) => {
  return collection.take(expr);
};
export {
  $limit
};
